import { screenToWorld, worldToScreen } from "./viewport";
export default function drawAlignmentDots(alignmentCanvas, alignmentCtx, camera) {
    alignmentCtx.clearRect(0, 0, alignmentCanvas.width, alignmentCanvas.height);
    alignmentCtx.fillStyle = "rgba(255, 255, 255, 0.1)";
    const dotSize = 1;
    let spacing = 50;
    while (spacing * camera.zoom < 25) {
        spacing *= 2;
    }
    const topLeft = screenToWorld({ x: 0, y: 0 }, camera);
    const bottomRight = screenToWorld({ x: alignmentCanvas.width, y: alignmentCanvas.height }, camera);
    const startingOffset = 25;
    const startX = Math.ceil((topLeft.x - startingOffset) / spacing) * spacing +
        startingOffset;
    const startY = Math.ceil((topLeft.y - startingOffset) / spacing) * spacing +
        startingOffset;
    for (let x = startX; x <= bottomRight.x; x += spacing) {
        for (let y = startY; y <= bottomRight.y; y += spacing) {
            const screenPoint = worldToScreen({ x, y }, camera);
            alignmentCtx.beginPath();
            alignmentCtx.arc(screenPoint.x, screenPoint.y, dotSize, 0, Math.PI * 2);
            alignmentCtx.fill();
        }
    }
}
